module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"completion":"Completion","completionLevel":{"high":"> 66%","medium":"33-66%","low":"< 33%"}},"fr":{"completion":"Avancement","completionLevel":{"high":"> 66%","medium":"33-66%","low":"< 33%"}}}')
  delete Component.options._Ctor
}
